//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { shareFun } from '@/util/const'
import { VIDEO_SRC, SHARE_INFO } from './stories'

export default {
  name: 'storyList',
  data () {
    return {
      stories: VIDEO_SRC
    }
  },
  created () {
    shareFun({
      type: 1,
      title: SHARE_INFO.title,
      content: SHARE_INFO.content,
      url: window.location.href,
      img: `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`
    })
  },
  methods: {
    gotoDetail (story) {
      this.$router.push(`/5g-story/${story.key}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/5gRewritesStory/list.vue